import axios from '../../lib/axios'
var log = console.log
import _ from 'lodash'

// initial state
// shape: [{ id, quantity }]
const state = {
  profile: {
    img: '',
    name_last: '',
    name_first: '',
    name_display: '',
    other: {}
  },
  uuid: '',
  email: '',
  roles: [],
  auth: ''
}

// getters
const getters = {
    profile: state => state.profile,
    uuid: state => state.uuid,
    email: state => state.email,
    auth: state => state.auth,
    roles: state => state.roles || [],
    loggedIn: state => !!state.auth
}

// actions
const actions = {
    email({ commit }, e) {
        commit('email', e)
    },
    uuid({ commit }, u) {
        commit('uuid', u)
    },
    profile({ commit }, p) {
        commit('profile', p)
    },
    register({ commit }, data) {
        return new Promise((resolve, reject) => {

            axios.post('/api/user/register', data)
            .then(function (response) {
            // This re-requests the transaction details
                var d = response.data;
                if (d.status!="success") { 
                    reject(d); 
                } else {
                    commit('noop')
                    //var auth = response.data.data['auth'];
                    //self.$store.dispatch('Login')
                }
                resolve(d);
            })
            .catch((err) => {
                log('ERROR','user:register', err.message)
                reject(err)
            });
        });
    },
    login({commit}, a) {
        return new Promise((resolve, reject) => {
            axios.post('/api/user/login', {
                "auth": a.auth, // self.$store.getters.auth,
                "email": a.email // self.$store.getters.email
            })
            .then(function (response) {
            // This re-requests the transaction details
                var d = response.data;
                if (d.status!="success") {
                    reject(d);
                } else {
                    axios.defaults.headers.common = {
                        "Authorization" : "Bearer " + d.data['auth']
                    }

                    commit('email', a.email)
                    commit('uuid', d.data['uuid'])
                    commit('auth', d.data['auth'])
                    commit('roles', d.data['roles'])
                    commit('profile', { 
                        name_last : d.data['name_last'],
                        name_first : d.data['name_first'],
                        name_display : d.data['name_display'],
                        other : d.data['profile'],
                    })
                }
		window.location.reload()
                resolve(d)
            })
            .catch((err) => {
                log('ERROR','user:login', err.message)
                reject(err)
            });
        });
    },
    logout({commit}) {
        axios.get('/api/user/logout')
        commit('email', '')
        commit('uuid', '')
        commit('roles', [])
        commit('auth', '')
        commit('profile', { })
    }
}

// mutations
const mutations = {
  email (state, e) {
//  /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(e)
    state.email = e;
  },
  profile (state, p) {
    _.merge(state.profile, p);
    state.profile = p;
  },
  uuid (state, u) {
      state.uuid = u
  },
  roles (state, rs) {
      state.roles = rs
  },
  auth (state, a) {
      state.auth = a
  },
  noop () { }
}

export default {
  state,
  getters,
  actions,
  mutations
}
